import React from "react";
import { Route, IndexRoute } from "react-router";
import MainLayout from "../layouts/MainLayout.web.js";
import Main from "../containers/Main";
import StartInstall from "../containers/StartInstall";
import Serial from "../containers/Serial";
import WiredConnection from "../containers/WiredConnection";
import WirelessConnection from "../containers/WirelessConnection";
import WirelessSelection from "../containers/WirelessSelection";
import SoftwareInstallation from "../containers/SoftwareInstallation";
import ConnectionType from "../containers/ConnectionType";
import ManualAddress from "../containers/ManualAddress";
import KitNumber from "../containers/kit/KitNumber";
import KitVerify from "../containers/KitVerify";
import Validation from "../containers/Validation";
import InternetCheck from "../containers/InternetCheck";
import AddressValidation from "../containers/AddressValidation";
import ReplaceValidation from "../containers/ReplaceValidation";
import ReplaceInstall from "../containers/ReplaceInstall";
import ComponentSelection from "../containers/kit/ComponentSelection";
import SiteDetails from "../containers/kit/SiteDetails";
import InverterSets from "../containers/kit/InverterSets";
import ComponentList from "../containers/kit/ComponentList";
import KitSummary from "../containers/kit/KitSummary";
import EdmiSerial from "../containers/kit/EdmiSerial";

export default (
  <Route path="/" component={MainLayout}>
    <IndexRoute component={Main} pageKey={"Main"} depth={1} />
    <Route
      path="StartInstall"
      component={StartInstall}
      pageKey={"StartInstall"}
      depth={2}
    />
    <Route path="Serial" component={Serial} pageKey={"Serial"} depth={3} />
    <Route
      path="ManualAddress"
      component={ManualAddress}
      pageKey={"ManualAddress"}
      depth={4}
    />
    <Route
      path="KitNumber"
      component={KitNumber}
      pageKey={"KitNumber"}
      depth={5}
    />
    <Route
      path="EdmiSerial"
      component={EdmiSerial}
      pageKey={"EdmiSerial"}
      depth={7}
    />
    <Route
      path="SiteDetails"
      component={SiteDetails}
      pageKey={"SiteDetails"}
      depth={8}
    />
    <Route
      path="InverterSets"
      component={InverterSets}
      pageKey={"InverterSets"}
      depth={9}
    />
    <Route
      path="ComponentList"
      component={ComponentList}
      pageKey={"ComponentList"}
      depth={10}
    />
    <Route
      path="ComponentSelection"
      component={ComponentSelection}
      pageKey={"ComponentSelection"}
      depth={11}
    />
    <Route
      path="KitSummary"
      component={KitSummary}
      pageKey={"KitSummary"}
      depth={12}
    />
    <Route
      path="KitVerify"
      component={KitVerify}
      pageKey={"KitVerify"}
      depth={13}
    />
    <Route
      path="ConnectionType"
      component={ConnectionType}
      pageKey={"ConnectionType"}
      depth={14}
    />
    <Route
      path="WiredConnection"
      component={WiredConnection}
      pageKey={"WiredConnection"}
      depth={15}
    />
    <Route
      path="WirelessConnection"
      component={WirelessConnection}
      pageKey={"WirelessConnection"}
      depth={16}
    />
    <Route
      path="WirelessSelection"
      component={WirelessSelection}
      pageKey={"WirelessSelection"}
      depth={17}
    />
    <Route
      path="SoftwareInstallation"
      component={SoftwareInstallation}
      pageKey={"SoftwareInstallation"}
      depth={18}
    />
    <Route
      path="Validation"
      component={Validation}
      pageKey={"Validation"}
      depth={19}
    />
    <Route
      path="SerialValidate"
      component={Serial}
      pageKey={"SerialValidate"}
      depth={1}
    />
    <Route
      path="Revalidate"
      component={Validation}
      pageKey={"Revalidate"}
      depth={2}
    />
    <Route
      path="ReplaceInstall"
      component={ReplaceInstall}
      pageKey={"ReplaceInstall"}
      depth={1}
    />
    <Route
      path="SerialReplace"
      component={Serial}
      pageKey={"SerialReplace"}
      depth={2}
    />
    <Route
      path="InternetCheck"
      component={InternetCheck}
      pageKey={"InternetCheck"}
      depth={3}
    />
    <Route
      path="AddressValidation"
      component={AddressValidation}
      pageKey={"AddressValidation"}
      depth={4}
    />
    <Route
      path="ReplaceValidation"
      component={ReplaceValidation}
      pageKey={"ReplaceValidation"}
      depth={5}
    />
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes/index.js